import {
  PAYMENT_INIT_LOADING_ACTION,
  PAYMENT_INIT_INFORMATION_ACTION,
  TOGGLE_PAYMENT_INFORMATION_COMPONENT_ACTION,
  SAVE_CONTRACT_CODES,
  
} from '../actions'

import {SAVE_MERCHANT_CODE} from 'actions/auth'
export const INIT_STATE = {
  loading: false,
  contractCodes: [],
  merchantCode: null,
  paymentData: {
    accountNumber: null,
    accountName: null,
    bankName: null,
    accountDurationSeconds: 30,
    requestTime: null,
    transactionReference: null,
    paymentReference: null,
  },
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_MERCHANT_CODE:
      return { ...state, merchantCode: action.payload }
    case SAVE_CONTRACT_CODES:
      return { ...state, contractCodes: action.payload }
    case TOGGLE_PAYMENT_INFORMATION_COMPONENT_ACTION:
      return { ...state, showPaymentInformation: action.payload }
    case PAYMENT_INIT_INFORMATION_ACTION:
      if (action.payload) {
        return { ...state, paymentData: action.payload }
      } else {
        return { ...state, paymentData: INIT_STATE }
      }
    case PAYMENT_INIT_LOADING_ACTION:
      return { ...state, loading: action.payload }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/modules/Simulator/MainApp/reducers/index.js